import { Component } from '@angular/core';

@Component({
  selector: 'app-root',
  templateUrl: './app1.component.html',
  styleUrls: ['./app1.component.css']
})
export class AppComponent {

}
